import ApiServer from '@/utils/api/ApiServer.js'
import { logLengthSorter } from '@/components/account/account-scaling/log-lengths/LogLengths.js'
import { lengthGroupSorter, sortLengthsWithinGroups } from '@/components/account/account-scaling/length-groups/LengthGroups.js'
import { diameterGroupSorter } from '@/components/account/account-scaling/diameter-groups/DiameterGroups.js'
import {
  speciesGroupSorter, sortSpeciesWithinGroups, sortLengthGroupsWithinSpeciesGroups,
  sortDiameterGroupsWithinSpeciesGroups
} from '@/components/account/account-scaling/species-groups/SpeciesGroups'

const ACCOUNTS = 'accounts'
const LOG_LENGTHS = 'logLengths'
const LENGTH_GROUPS = 'lengthGroups'
const DIAMETER_GROUPS = 'diameterGroups'
const SPECIES_GROUPS = 'speciesGroups'

function safeSort (responseData, sortingFunction) {
  if (responseData && responseData.length > 1) {
    responseData.sort(sortingFunction)
  }
}

export default {
  async fetchAccountLogLengths (context, accountId) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${LOG_LENGTHS}`)
    safeSort(response?.data, logLengthSorter)
    context.commit('setLogLengths', response.data)
    return response.data
  },
  async createAccountLogLengths (context, { accountId, logLengths }) {
    const response = await ApiServer.post(`${ACCOUNTS}/${accountId}/${LOG_LENGTHS}`, { accountId: accountId, logLengths: logLengths })
    safeSort(response?.data, logLengthSorter)
    context.commit('setLogLengths', response.data)
    return response.data
  },
  async deleteAccountLogLength (_, { accountId, logLengthId }) {
    const response = await ApiServer.delete(`${ACCOUNTS}/${accountId}/${LOG_LENGTHS}/${logLengthId}`)
    return response.data
  },
  async deleteAccountLogLengths (_, accountId) {
    const response = await ApiServer.delete(`${ACCOUNTS}/${accountId}/${LOG_LENGTHS}`)
    return response.data
  },

  async fetchAccountLengthGroups (context, accountId) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${LENGTH_GROUPS}`)
    safeSort(response?.data, lengthGroupSorter)
    sortLengthsWithinGroups(response?.data)
    context.commit('setLengthGroups', { lengthGroups: response.data, accountId })
    return response.data
  },
  async fetchAccountLengthGroup (_, { accountId, lengthGroupId }) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${LENGTH_GROUPS}/${lengthGroupId}`)
    return response.data
  },
  async createAccountLengthGroup (_, lengthGroup) {
    const response = await ApiServer.post(`${ACCOUNTS}/${lengthGroup.accountId}/${LENGTH_GROUPS}`, lengthGroup)
    return response.data
  },
  async updateAccountLengthGroup (_, lengthGroup) {
    const response = await ApiServer.put(`${ACCOUNTS}/${lengthGroup.accountId}/${LENGTH_GROUPS}/${lengthGroup.lengthGroupId}`, lengthGroup)
    return response.data
  },
  async deleteAccountLengthGroup (_, { accountId, lengthGroupId }) {
    const response = await ApiServer.delete(`${ACCOUNTS}/${accountId}/${LENGTH_GROUPS}/${lengthGroupId}`)
    return response.data
  },

  async fetchAccountDiameterGroups (context, accountId) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${DIAMETER_GROUPS}`)
    safeSort(response?.data, diameterGroupSorter)
    context.commit('setDiameterGroups', { diameterGroups: response.data, accountId })
    return response.data
  },
  async fetchAccountDiameterGroup (_, { accountId, diameterGroupId }) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${DIAMETER_GROUPS}/${diameterGroupId}`)
    return response.data
  },
  async createAccountDiameterGroup (_, diameterGroup) {
    const response = await ApiServer.post(`${ACCOUNTS}/${diameterGroup.accountId}/${DIAMETER_GROUPS}`, diameterGroup)
    return response.data
  },
  async updateAccountDiameterGroup (_, diameterGroup) {
    const response = await ApiServer.put(`${ACCOUNTS}/${diameterGroup.accountId}/${DIAMETER_GROUPS}/${diameterGroup.diameterGroupId}`, diameterGroup)
    return response.data
  },
  async deleteAccountDiameterGroup (_, { accountId, diameterGroupId }) {
    const response = await ApiServer.delete(`${ACCOUNTS}/${accountId}/${DIAMETER_GROUPS}/${diameterGroupId}`)
    return response.data
  },

  async fetchAccountSpeciesGroups (context, accountId) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${SPECIES_GROUPS}`)
    safeSort(response?.data, speciesGroupSorter)
    sortSpeciesWithinGroups(response?.data)
    sortLengthGroupsWithinSpeciesGroups(response?.data)
    sortDiameterGroupsWithinSpeciesGroups(response?.data)
    context.commit('setSpeciesGroups', response.data)
    return response.data
  },
  async fetchAccountSpeciesGroup (_, { accountId, speciesGroupId }) {
    const response = await ApiServer.get(`${ACCOUNTS}/${accountId}/${SPECIES_GROUPS}/${speciesGroupId}`)
    return response.data
  },
  async createAccountSpeciesGroup (_, speciesGroup) {
    const response = await ApiServer.post(`${ACCOUNTS}/${speciesGroup.accountId}/${SPECIES_GROUPS}`, speciesGroup)
    return response.data
  },
  async updateAccountSpeciesGroup (_, speciesGroup) {
    const response = await ApiServer.put(`${ACCOUNTS}/${speciesGroup.accountId}/${SPECIES_GROUPS}/${speciesGroup.speciesGroupId}`, speciesGroup)
    return response.data
  },
  async deleteAccountSpeciesGroup (_, { accountId, speciesGroupId }) {
    const response = await ApiServer.delete(`${ACCOUNTS}/${accountId}/${SPECIES_GROUPS}/${speciesGroupId}`)
    return response.data
  }
}
